import { render, staticRenderFns } from "./InsertValuesTemperatureBulk.vue?vue&type=template&id=33345081&"
import script from "./InsertValuesTemperatureBulk.vue?vue&type=script&lang=js&"
export * from "./InsertValuesTemperatureBulk.vue?vue&type=script&lang=js&"
import style0 from "./InsertValuesTemperatureBulk.vue?vue&type=style&index=0&id=33345081&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports